const binStringToArrayBuffer = (bin) => {
  const length = bin.length;
  const buf = new ArrayBuffer(length);
  const arr = new Uint8Array(buf);
  for (let i = 0; i < length; i++) { // eslint-disable-line no-plusplus
    arr[i] = bin.charCodeAt(i);
  }
  return buf;
};

function createBlob(parts, properties) {
  try {
    return new Blob(parts, properties);
  } catch (e) {
    if (e.name !== 'TypeError') {
      throw e;
    }
    /* eslint-disable no-nested-ternary,no-undef */
    const Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
      typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
        typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder :
          WebKitBlobBuilder;
    /* eslint-enable no-nested-ternary,no-undef */
    const builder = new Builder();
    for (let i = 0; i < parts.length; i += 1) {
      builder.append(parts[i]);
    }
    return builder.getBlob(properties.type);
  }
}

const decodeBlob = (encodedBlob) => {
  const arrayBuff = binStringToArrayBuffer(atob(encodedBlob.data));
  return createBlob([arrayBuff], { type: encodedBlob.type });
};

/**
 * Transforms the object stored in IndexedDB into a blob object.
 *
 * It manages objects whose "data" field is a base 64 or directly an array buffer.
 * Attachments are now stored in an array buffer. However, the application must
 * manage previously stored documents.
 *
 */
/* eslint-disable import/prefer-default-export */
export const transformStoredAttachmentToBlob = (storedObject) => {
  if (typeof storedObject.data === 'string') {
    return decodeBlob(storedObject);
  }

  return new Blob(
    [storedObject.data],
    { type: storedObject.type }
  );
};



// WEBPACK FOOTER //
// ./book/src/attachments/attachmentTransformer.js